export type V3AgentModelProvider = 'anthropic' | 'openai' | 'fireworks';

export type V3AgentModelOption = {
    readonly id: string;
    readonly label: string;
    readonly provider: V3AgentModelProvider;
};

// This list is deliberately owned by the native v3 feature. Saved v2 chats
// continue to use the legacy picker and its broader model list.
export const V3_AGENT_MODEL_OPTIONS: ReadonlyArray<V3AgentModelOption> = [
    { id: 'claude-opus-4-8', label: 'Opus 4.8', provider: 'anthropic' },
    { id: 'claude-sonnet-5', label: 'Sonnet 5', provider: 'anthropic' },
    {
        id: 'claude-haiku-4-5-20251001',
        label: 'Haiku 4.5',
        provider: 'anthropic',
    },
    { id: 'gpt-5.6-sol', label: 'GPT-5.6 Sol', provider: 'openai' },
    { id: 'gpt-5.6-terra', label: 'GPT-5.6 Terra', provider: 'openai' },
    { id: 'gpt-5.6-luna', label: 'GPT-5.6 Luna', provider: 'openai' },
    {
        id: 'accounts/fireworks/models/deepseek-v4-pro',
        label: 'DeepSeek V4 Pro',
        provider: 'fireworks',
    },
    {
        id: 'accounts/fireworks/models/kimi-k3',
        label: 'Kimi K3',
        provider: 'fireworks',
    },
];
